import React, { useContext, useEffect, useState } from "react";
import "./Common_Vendor_Card.css";
import Common_Send_Button from "../common-send-button/Common_Send_Button";
import Common_Call_Button from "../common-send-button/common-call-button/Common_Call_Button";
import Send_Button_Modal from "../common-modals/send-btn-modal/Send_Button_Modal";
import Call_Now_Modal from "../common-modals/call-now-modal/Call_Now_Modal";
import { IDS } from "../../../utils/IDS";
import { Context } from "../../../utils/context";
import Subscription_Needed_Lottie_Modal from "../subscription-needed-lottie-modal/Subscription_Needed_Lottie_Modal";
import { useNavigate } from "react-router-dom";
const Common_Vendor_Card = ({ vendor, onClick, onClick2 }) => {
  useEffect(() => {
    const slider = document.querySelector(".category-scroll-container");
    if (!slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => (isDown = false));
    slider.addEventListener("mouseup", () => (isDown = false));

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    });
  }, []);
  const [showInquiry, setShowInquiry] = useState(false);
  const [showCall, setShowCall] = useState(false);
  const navigate = useNavigate();
  console.log(vendor, "vendorvendorvendor");

  const { signin, userdata } = useContext(Context);

  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

  const hasSubscription =
    userdata?.subscription_status === true &&
    Array.isArray(userdata?.user_subscription) &&
    userdata.user_subscription.length > 0;

  // ✅ Inquiry Click
  const handleInquiryClick = () => {
    if (!hasSubscription) {
      setShowSubscriptionModal(true);
      return;
    }
    setShowInquiry(true); // existing flow
  };

  // ✅ Call Click
  const handleCallClick = () => {
    if (!hasSubscription) {
      setShowSubscriptionModal(true);
      return;
    }
    setShowCall(true); // existing flow
  };

  if (!vendor) return null;

  const vendorImg = vendor?.user?.vendor_shop_image?.[0]?.shop_image
    ? `${IDS.IMG_URL}${vendor?.user?.vendor_shop_image[0]?.shop_image}`
    : "/assets/images/vendors/vendor1.png";

  return (
    <>
      <div className="vendor-card">
        {/* <div className="card-image">
          <img src={vendor.image} alt={vendor?.name} />
        </div> */}

        <div className="card-content">
          <div className="vendor-name-holder">
            {/* {vendor?.verified && ( */}
            {/* <img
              src={`${IDS.IMG_URL}${vendor?.user?.vendor_shop_image?.[0]?.shop_image}`}
              alt="Verified"
              className="vendor-card-img"
            /> */}
            <img src={vendorImg} alt="vendor" className="vendor-card-img" />
            {/* )} */}
          </div>
          <div className="card_data p-2">
            <div className="vendor-name vendor-name-holder">
              <span>{vendor?.user?.vendor_shop_detail?.shop_name}</span>

              <div className="rating">
                <p>
                  ⭐
                  {vendor?.user?.average_rating?.avg_rating
                    ? parseFloat(
                        vendor?.user?.average_rating?.avg_rating,
                      ).toFixed(1)
                    : "4.0"}
                  /5
                </p>
              </div>
            </div>
            <div className="location">
              {[
                vendor?.user?.user_details?.state?.name,
                vendor?.user?.user_details?.district?.name,
              ]
                .filter(Boolean) // removes undefined/null
                .join(", ") || "N/A"}
            </div>

            <div className="material">
              <strong>Material :- </strong>
              {vendor?.user?.vendor_shop_detail?.service_category?.length > 0
                ? vendor.user.vendor_shop_detail.service_category
                    .map((item) => item?.material?.name)
                    .filter(Boolean)
                    .join(", ")
                : "N/A"}
            </div>

            <div className="description">
              <strong>Description :- </strong>
              {vendor?.user?.vendor_shop_detail?.description}
            </div>
            {/* <div className="buttons">
            <Common_Send_Button onClick={() => setShowInquiry(true)} />
            <Common_Call_Button onClick2={() => setShowCall(true)} />
          </div> */}
          </div>
          <div className="buttons">
            <Common_Send_Button onClick={handleInquiryClick} />
            <Common_Call_Button onClick={handleCallClick} />
          </div>
        </div>
      </div>

      {showInquiry && (
        <Send_Button_Modal
          show={showInquiry}
          handleClose={() => setShowInquiry(false)}
          vendor={vendor}
        />
      )}
      <Call_Now_Modal
        show={showCall}
        handleClose={() => setShowCall(false)}
        vendor={vendor}
      />
      <Subscription_Needed_Lottie_Modal
        showSubscription={showSubscriptionModal}
        handleSubscriptionClose={() => {
          setShowSubscriptionModal(false);
          navigate("/wallet");
        }}
      />
    </>
  );
};

export default Common_Vendor_Card;
